export default "__VITE_ASSET__C64n7M9E__"